"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const Imprint_1 = __importDefault(require("../../../common/components/Other/Imprint"));
const HomeBottomCta_1 = __importDefault(require("../../../common/components/Other/HomeBottomCta"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const WeatherIcon_1 = __importDefault(require("../../../common/components/Weather/WeatherIcon"));
const VenueTiles_1 = __importDefault(require("../Tiles/VenueTiles"));
const VenueScreenList_1 = __importDefault(require("./Redesign/VenueScreenList"));
const DownloadApp_1 = __importDefault(require("../Other/DownloadApp"));
const NotificationPermissions_1 = __importDefault(require("../Notifications/NotificationPermissions"));
const globalVariables_1 = require("../../../common/globalVariables");
const useAppUid_1 = require("../../behaviours/useAppUid");
const VenueScreenWrapper = styled_components_1.default.div `
  padding-bottom: 88px;

  .permission-controls {
    margin: 16px auto 16px;
    width: auto;
    position: relative;
    max-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px;
    padding: 0 16px;

    @media (min-width: ${globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT}px) {
      padding: 0;
    }
  }
`;
const MainImage = styled_components_1.default.div `
  height: 30vh;
  position: relative;

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;

  background-image: ${(props) => `linear-gradient(to top, rgba( 0, 0, 0, 0.5), rgba(0, 0, 0, 0.0)), url(${props.Lpic} )`};

  @media (min-width: 600px) {
    background-image: ${(props) => `linear-gradient(to top, rgba( 0, 0, 0, 0.5), rgba(0, 0, 0, 0.0)), url(${props.XXLpic} )`};
  }

  .main-title {
    font-size: 1.25rem;
    display: flex;
    align-items: flex-end;
    color: #fff;

    @media (min-width: 769px) {
      font-size: 2.125rem;
    }
  }
`;
const TitleWeatherStrip = styled_components_1.default.div `
  margin: 0 auto;
  max-width: ${(props) => props.maxWidthTitleAndStrip}px;
  width: 100%;

  display: flex;
  justify-content: space-between;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;

  padding: 10px 16px;
  color: white;

  p {
    font-size: 1.4rem;
    margin: 0;
  }
  @media (min-width: ${(props) => props.maxWidthTitleAndStrip}px) {
    padding: 20px 0;
  }
`;
const WeatherChip = styled_components_1.default.div `
  width: 80px;
  height: 40px;
  padding: 5px;
  background: rgba(0, 0, 0, 0.502);
  border-radius: 20px;
  display: flex;
  color: #fff;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 40%);

  .weather-icon {
    flex-basis: 35px;
    > i {
      display: flex;
      > svg {
        flex-basis: 100%;
      }
    }
  }
  &:hover {
    cursor: pointer;
  }
`;
const CurrentTemperature = styled_components_1.default.div `
  flex-basis: 40px;
  text-align: center;
`;
const VenueScreen = (props) => {
    const { homeBottomCta, updateStore, hotelView, baseUrl, location } = props;
    (0, useAppUid_1.useAppUid)();
    (0, react_1.useEffect)(() => {
        updateStore("kioskModeEnabled", false);
    }, []);
    const goToWeather = () => {
        props.history.push({
            pathname: `${baseUrl}/weather`,
            search: location.search,
        });
    };
    return (react_1.default.createElement(VenueScreenWrapper, { homeBottomCta: homeBottomCta },
        react_1.default.createElement(MainImage, { Lpic: hotelView.L, XXLpic: hotelView.XXL },
            react_1.default.createElement(TitleWeatherStrip, { maxWidthTitleAndStrip: globalVariables_1.WEB_APP.MAX_WIDTH_HOME_SCREEN_CONTENT },
                react_1.default.createElement(material_1.Typography, { variant: "h4", className: "main-title" }, document.title),
                props.weatherData.current && (react_1.default.createElement(WeatherChip, { id: "aqa_homepage_weatherchip", onClick: goToWeather },
                    react_1.default.createElement(WeatherIcon_1.default, { symbol: props.weatherData.current.symbol, whiteTransparentVariant: true }),
                    react_1.default.createElement(CurrentTemperature, null,
                        `${props.weatherData.current.temperature}`,
                        "\u00B0"))))),
        react_1.default.createElement(NotificationPermissions_1.default, null),
        react_1.default.createElement(VenueTiles_1.default, null),
        react_1.default.createElement(DownloadApp_1.default, null),
        react_1.default.createElement(VenueScreenList_1.default, null),
        react_1.default.createElement(Imprint_1.default, null),
        homeBottomCta && react_1.default.createElement(HomeBottomCta_1.default, { data: homeBottomCta })));
};
const mapStoreToProps = (store) => ({
    hotelView: store.getValue("hotelView"),
    homeBottomCta: store.getValue("homeBottomCta"),
    weatherData: store.getValue("weather"),
    baseUrl: store.getValue("baseUrl"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(VenueScreen));
